module.exports = __webpack_public_path__ + "img/game_main_pc_280_off.e1aef9b7.png";